module.exports = __webpack_public_path__ + "dc838bf91144595e95c5372a88ed1f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-8.png
// module id = 312
// module chunks = 1